import { render, staticRenderFns } from "./CabinetCreateComponent.vue?vue&type=template&id=6e9534e8&scoped=true&"
import script from "./CabinetCreateComponent.vue?vue&type=script&lang=js&"
export * from "./CabinetCreateComponent.vue?vue&type=script&lang=js&"
import style0 from "./CabinetCreateComponent.vue?vue&type=style&index=0&id=6e9534e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9534e8",
  null
  
)

export default component.exports